export const ERROR_PAYMENT_METHOD = "There was an error processing payment method.";